import React, { useEffect } from "react";

import '../SCSS/BlogPage.scss'
import writer from '../Images/blog/writerLY.png'
import forensicsBlog from '../Images/blog/forensics-blog.jpg'
import blogPosts from "../blog-info";

const Blog = () => {

    const key = sessionStorage.getItem('blog-event')

    return(
        <div className="main blog-page">
            
            <h1>{blogPosts[key].title}</h1>

            <div className="writer">
                <img src={writer} alt="" />
                <p className="name">Liang Ying</p>
                <div className="divider"></div>
                <p className="date">25 January 2020</p>
            </div>
            <div className="main-image">
                <img src={blogPosts[key].image} alt="" />
            </div>
            <p className="main-passage">
                {blogPosts[key].content}
            </p>
            <div className="bottom-writer">
                <img src={writer} alt="" />
                <div className="content">
                    <h4>WRITTEN BY</h4>
                    <h3>Liang Ying</h3>
                    <p>Business Manager at ANOR Technologies</p>
                </div>
            </div>
        </div>
    )
}

export default Blog